import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../../common/Layout";
import Breadcrumb from "../../../common/breadcrumb/Breadcrumb";
import ClientLogo from "../../../components/client-logo/ClientLogo";
import { Helmet } from "react-helmet";

const ServiceDetailsOne = () => {
  const [services, setServices] = useState(null);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await fetch(
           "https://portal.ebs365.info/api/sites/3/list/services"
        );
        const data = await response.json();
        setServices(data);
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    };

    fetchSiteSettings();
  }, []);

  // console.log("servicesde", services);

  const { id } = useParams();
  // const serviceData = getServiceData.filter( service => service.id === parseInt(id) )[0];
  let heroSection = null;
  if (services && services.data) {
    heroSection = services.data.filter(
      (service) => service.id === parseInt(id)
    )[0];
  }

  console.log("details", heroSection);

  return (
    <>
      <Helmet>
        <title>
         RSS Security and Investigations Pty Ltde
        </title>
        <meta
          name="description"
          content="Securepress - Security Company React  Template"
        />
        <meta
          name="keywords"
          content="safety, bodyguard, cctv, emergency, Event Security, fire, investigation, investigator, officer, protection, security, Security Camera, Care, Parking  Security"
        />
      </Helmet>
      <Layout>
        <Breadcrumb
          pageTitle={heroSection && heroSection.title ? heroSection.title : null}
          rootPath="/"
          parentPath="Home"
          currentPath={heroSection && heroSection.title ? heroSection.title : null}
        />
        <div className="about-us-sec pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div className="abt-img">

                  <img src={heroSection && heroSection.images[0].path ? heroSection.images[0].path : "/images/no-image.png"} alt="backgroundimage" />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div className="abt-lft">
                  <h2>
                    {heroSection && heroSection.title
                      ? heroSection.title
                      : null}
                  </h2>

                  
                 

                  <div
                    dangerouslySetInnerHTML={{ __html: heroSection && heroSection.short_description ? heroSection.short_description : null }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <ClientLogo /> */}
      </Layout>
    </>
  );
};

export default ServiceDetailsOne;
